import { styled } from "styled-components";
import media from "../../../../../../styles/mediaQueries";
export const StyledSearchSuggestion = styled.a `
  border: 0;
  appearance: none;
  border-bottom: 1px solid #eee;
  padding: 0.5em 0;
  transition: all 0.2s ease-in-out;
  display: table;
  width: 100%;
  text-decoration: none !important;
  color: #000;
  table-layout: fixed;
  &:hover,
  &:focus {
    background: #f7f7f7;
    cursor: pointer;
    color: #000;
  }
`;
export const StyledSearchSuggestionInner = styled.div `
  position: relative;
  display: table-cell;
  vertical-align: middle;
  min-height: 60px;
  padding-left: 10px;
  &:after {
    content: "\\203A";
    position: absolute;
    right: 20px;
    top: calc(50% - 7px);
    transition: all 0.2s ease-in-out;
    text-decoration: none;
  }
`;
export const SearchSuggestionDescription = styled.small `
  display: inline-block;
  margin-bottom: -5px;
  background: #eee;
  padding: 5px 5px 3px;
  line-height: 1.3em;
`;
export const SearchSuggestionHeader = styled.h3 `
  margin: 0;
  padding: 5px 35px 0 0;
  width: 100%;
  position: relative;
  font-size: 18px;

  ${media.up("large") `
    font-weight: 400;
    line-height: 22px;
  `}
`;
export const SearchSuggestionIngress = styled.div `
  line-height: 19px;
  padding: 4px 0;
  max-width: 90%;
`;
export const StyledImage = styled.div `
  width: 75px;
  display: table-cell;
  margin-right: 0.25em;
  padding: 10px 10px 10px 0;
  -ms-flex-align: center;
  align-items: center;
  text-align: center;

  ${media.up("small") `
    width: 85px;
    padding: 10px;
  `}
  > div {
    width: 60px;
    height: 60px;
    background-image: url(https://d3vu3wbprz5gbr.cloudfront.net/img/fl-placeholder.jpg);
    background-size: cover;
    background-position: 50% 50%;
    border-radius: 50%;
  }
`;
//# sourceMappingURL=style.js.map